import ProfileSetting from '@/Component/Profile/ProfileSetting'
import SocialMediaAccount from '@/Component/Profile/ProfileSetting/SocialMediaAccount'

const SocialMediaAccountPage = () => {
    return (
        <ProfileSetting activeTab="social-media-account">
            <SocialMediaAccount />
        </ProfileSetting>
    )
}

export default SocialMediaAccountPage
